import { SPACING } from "./spacing"

// const CONTAINER = { lg: 1024, md: 768, sm: 640, xl: 1280 }

const _SIZES = {
  // "container": CONTAINER,
  ...SPACING,
  $2xl: 672,
  $2xs: 256,
  $3xl: 812,
  $3xs: 224,
  $4xl: 1024,
  $5xl: 1280,
  $lg: 512,
  $md: 448,
  $sm: 384,
  $xl: 576,
  $xs: 320,
}
export const SIZES = {
  ..._SIZES,
  $form: _SIZES.$2xl,
}

export type SizeToken = keyof typeof SIZES
